import { put } from "redux-saga/effects";
import { exclusionFone } from "../../Services";

export function* exclusionFoneSaga(action) {
  const payload = action.payload;
  try {
    const res = yield exclusionFone(payload);

    yield put({ type: "REQ_FONE_EXCLUSION_SUCCESS", data: res.data });
  } catch (error) {
    yield put({ type: "REQ_FONE_EXCLUSION_FAILED", data: error.response.data });
  }
}
